import { CLINIC_FIELDS } from '../models/field-definitions'
import { createDefaultClinic } from '../models/default-clinic'
import { getClinicColumns } from '../components/table-columns'

/**
 * ClinicTemplates
 *
 * This file serves as a facade for the clinic module's data structures.
 * The implementation details have been broken into smaller, more focused modules.
 */
const ClinicTemplates = {
  // Field definitions
  dataModel: CLINIC_FIELDS,

  // Default clinic object
  dataTemplate: createDefaultClinic,

  // Column configuration for tables
  columnTemplate: getClinicColumns
}

export default ClinicTemplates
